<div class="dialog-container dynamic-dialog">
  <h1 mat-dialog-title>
    {{ data.title | translate }}
  </h1>
  <mat-dialog-content> {{ data.message | translate }} {{ data?.item }} </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-dialog-close class="mr20 cancel-btn dialog-btn">
      {{ data.cancelText | translate }}
    </button>
    <button
      class="{{ data?.submitCssClass ? data?.submitCssClass : submitCssClass }} dialog-btn"
      (click)="submit()"
      mat-dialog-close
    >
      {{ data.submitText | translate }}
    </button>
  </mat-dialog-actions>
</div>
